import React from 'react';
import { connect } from 'react-redux';
import UnlockPremium from './UnlockPremium'
import { Modal, Button as AButton } from 'antd';
import { CheckIcon } from '../core/icons'

import {
  BrowserRouter as Router,
  Route,
  Link,
  Redirect
} from 'react-router-dom'

import styled from 'styled-components'

import { push, goBack } from 'react-router-redux'

import Accounts from '../account/bank-card/Accounts'
import {setPlaidImportHistory} from '../account/bank-card/actions'


export const Button = styled(AButton).attrs({
  type: props => props.primary && 'primary'
})`

  font-size: 18px;
  margin-top: 12px;
  text-transform: none !important;
  width: 100%;

  ${props=>props.fullWidth&&`
    width: 100%;
    height: 42px;
  `}
`

const Body = styled.div`
  padding: 5vmin;
  font-size: large;
  h1 {
    font-size: 25px;
    text-transform: capitalize;

  }
  > ol {
    list-style: decimal;
    padding-left: 30px;
    li {
      font-size: 18px;
      margin-bottom: 5px;
      padding: 1vmin 0;
    }
  }
`

const PlaidImportHistoryModal = ({ dispatch, message, title, buttonText, tokenId }) => (
  <Modal
    size='large'
    bodyStyle={{padding: 0}}
    visible={true}
    footer={null}
    closable={false}
    maskClosable={false}
  >
    <Body>
      <h1>Would you like to sync:</h1>

      <Button primary onClick={() =>{
        dispatch(setPlaidImportHistory("all"))
        dispatch({type:'HIDE_MODAL_2'})
      }}>Last 12 Months & Future Transactions</Button>

      <Button primary onClick={() =>{
         // dispatch({type: 'SET_PLAID_IMPORT_HISTORY', import_history: "30days"})
         dispatch(setPlaidImportHistory("last30"))
         dispatch({type:'HIDE_MODAL_2'})
      }}>Last 30 Days & Future Transactions</Button>

      <Button primary onClick={() =>{
        dispatch(setPlaidImportHistory("none"))
         dispatch({type:'HIDE_MODAL_2'})
      }}>Only Future Transactions</Button>

    </Body>
  </Modal>

)


export default connect(
  // mapStateToProps,
  // mapDispatchToProps
)(PlaidImportHistoryModal)



// WEBPACK FOOTER //
// ./src/modal/PlaidImportHistoryModal.js